<template>
	<div class="input-box">
			<van-field class="input-item" v-model="loginForm.username" clearable maxlength="11" :left-icon="require('@/assets/images/spark/account_icon.png')" placeholder="请输入账号" />
			<van-field class="input-item" :type="eyeOpen ? 'text' : 'password'" v-model="loginForm.password" clearable maxlength="18" :left-icon="require('@/assets/images/spark/password_icon.png')" placeholder="请输入密码">
				<van-image @click="eyeOpen=!eyeOpen" class="icon-eye" slot="right-icon" :src="eyeOpen ? require('@/assets/images/spark/password_show_icon.png') : require('@/assets/images/spark/password_close_icon.png')"></van-image>
			</van-field>
		<!-- <div class="forget-pw">
			<span>忘记密码？</span>
		</div> -->
		<slider-verify
			ref="sliderVerify"
			:appid="appid"
			:appsecret="appsecret"
			:block-height="50"
			:block-width="50"
			:disabled="disabled"
			:host="host"
			:slide-bg="slideBg"
			:slide-btn-bg="slideBtnBg"
			:canvas-width="canvasWidth"
			:canvas-height="200"
			style="width: 100%"
			@again="onAgain"
			@fail="onFail"
			@success="onSuccess"
		/>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				loginForm: {
          username: '', //手机号
          password: '', //密码
					sysFlag:-1,
					codeType:"slide"
        },
        host: "https://bs.datian360.com",//正式
        appid: "njwst",
        appsecret: "njwst",
        slideBtnBg: "#71B019",
        slideBg: "#71B019",
        disabled: false,
        canvasWidth: 370,
				eyeOpen:false,
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.canvasWidth = this.$refs.sliderVerify.$el.offsetWidth;
				//初始化滑块验证码插件
				this.$refs.sliderVerify.init();
			});
		},
  methods: {
     /**
     * @Description: 滑动成功
     * @Author: sunruyan
     * @Date: 2024-03-25 10:13:02
     * @param {*} captcha
     * @return {*}
     */
     onSuccess(captcha) {
      const { nonceStr, value } = captcha;
      this.loginForm.nonceStr = nonceStr;
      this.loginForm.value = value;
      this.$refs.sliderVerify.verifySuccessEvent();
      if (this.loginForm.username && this.loginForm.password) {
        this.submit();
        this.$refs.sliderVerify.refresh().catch((_) => {});
      } else {
        this.$toast("请先输入用户名，密码！");
        this.$refs.sliderVerify.refresh().catch((_) => {});
      }
    },
    /**
     * @Description: 滑动失败
     * @Author: sunruyan
     * @Date: 2024-03-25 10:13:22
     * @return {*}
     */
    onFail() {
      this.$refs.sliderVerify.verifyFailEvent();
    },
    /**
     * @Description: 滑动异常
     * @Author: sunruyan
     * @Date: 2024-03-25 10:13:33
     * @return {*}
     */
    onAgain() {
      this.$message.error("滑动验证失败，请重试");
      this.$refs.sliderVerify.refresh().catch((_) => {});
    },
		async submit() {
			let myreg = /^[1][0,1,2,3,4,6,5,7,8,9][0-9]{9}$/;
			if (!myreg.test(this.loginForm.username)) {
				this.$toast("请输入正确手机号");
				return;
			}
			if (!this.loginForm.password) {
				this.$toast("请输入密码");
				return;
			}
			this.$emit("submit",this.loginForm)
			// this.$store.dispatch("Login",this.loginForm).then(res => {
			// 	this.$toast("登录成功");
			// 	this.$store.dispatch("GetUserInfo");
			// 	// this.$router.push("/")
			// })
		},
      
    }
	}
</script>

<style lang="scss" scoped>
	.input-box{
		width: 100%;
		margin-top: 20px;
		.input-item{
			width: 100%;
			height: 54px;
			// line-height: 54px;
			border-radius: 9px;
			background: #ffffff;
			box-shadow: 0px 0px 18px rgba(0,0,0,0.08);
			display: flex;
			align-items: center;
			margin-bottom: 15px;
			line-height: normal;
			.icon-img{
				width: 18px;
				height: auto;
				margin-left: 12px;
			}
			.icon-eye{
				width: 18px;
				height: 10px;
			}
		}
		.forget-pw{
			padding-bottom: 20px;
			font-size: 16px;
			color: #888888;
			text-align: right;
		}
		
	}
</style>